// API for QuanLyMauHopDong
import { API_AUTH } from '../../common';


const QuanLyMauHopDongApi = {
  getList: (params) => API_AUTH.get('QuanLyMauThuChi/danhsach', params ),
  addOrUpdate: (data) => API_AUTH.post('QuanLyMauThuChi/addorupdate', data),
  delete: (id) => API_AUTH.delete(`api/mauhopdong/${id}`),
};

export default QuanLyMauHopDongApi;
